export { default as ARTICLE_TAGS } from './tags';
export const ARTICLES_PER_PAGE = 12;
